import React from 'react';
import noop from 'lodash/noop';
import isNil from 'lodash/isNil';
import {
  PayerEntryConfigDTO,
} from 'dtos';
import BaseDialog from 'pages/Dashboard/components/Dialog';
import {
  PayerType,
} from 'views/EMR/Settings/Payers/index';
import capitalize from 'lodash/capitalize';
import ElectronicPayerForm from 'views/EMR/Settings/Payers/ElectronicPayerForm';
import PaperPayerForm from 'views/EMR/Settings/Payers/PaperPayerForm';

export type PayerConfigDialogParams = {
  data?: PayerEntryConfigDTO;
  type?: PayerType;
};
type Props = PayerConfigDialogParams & {
  onClose: () => void;
};

export default function Dialog({
  data,
  type = 'electronic',
  onClose,
}: Props) {
  const isNew = isNil(data);
  const isElectronic = type === 'electronic';
  const Form = isElectronic ? ElectronicPayerForm : PaperPayerForm;
  const title = `${isNew ? 'Add' : 'Edit'} ${capitalize(type)} Payer${isElectronic ? ' Configuration' : ''}`;

  return (
    <BaseDialog
      title={(
        <div className="flex flex-1 flex-col gap-4">
          <h2 className="text-lg font-semibold">
            {title}
          </h2>
        </div>
      )}
      closeBtnClasses="!-top-1"
      onClose={onClose}
      onConfirm={noop}
      className="!w-[40rem] populate-form"
      maxWidth="lg"
      open
    >
      <Form
        data={data}
        onClose={onClose}
      />
    </BaseDialog>
  );
}
